import React from 'react';

type Props = {
  text?: string;
};

const Dots = ({ text = '…' }: Props) => {
  return (
    <>
      <div className="dot-flashing"></div>
    </>
  );
}

export default Dots;